/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @version 1.0.0
 * @since 1.0.0
 */

/**
 * Control long polling constants
 * @type {string}
 */
export const START_POLLING = '@@b2b_portal_ui/polling/START_POLLING';
export const STOP_POLLING = '@@b2b_portal_ui/polling/STOP_POLLING';
export const SET_REQUEST_PARAMS = '@@b2b_portal_ui/polling/SET_REQUEST_PARAMS';

/**
 * Fetch result constants
 * @type {string}
 */
export const FETCH_SUCCESS = '@@b2b_portal_ui/polling/FETCH_SUCCESS';
export const FETCH_FAILURE = '@@b2b_portal_ui/polling/FETCH_FAILURE';
